import { useNavigate } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Eye } from 'lucide-react';
import { Region } from '@/features/regions/types';

interface RegionTableProps {
  regions: (Region & { provider_name?: string })[];
  showProviderName?: boolean;
  showVersions?: boolean;
}

export function RegionTable({ regions, showProviderName = false, showVersions = true }: RegionTableProps) {
  const navigate = useNavigate();

  const handleViewVersions = (region: Region) => {
    navigate(`/providers/${region.provider_id}/regions/${region.id}/versions`);
  };

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Zip Code</TableHead>
            {showProviderName && <TableHead>Provider</TableHead>}
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {regions.length === 0 ? (
            <TableRow>
              <TableCell 
                colSpan={showProviderName ? 4 : 3} 
                className="text-center"
              >
                No regions found
              </TableCell>
            </TableRow>
          ) : (
            regions.map((region) => (
              <TableRow key={region.id}>
                <TableCell className="font-medium">{region.name}</TableCell>
                <TableCell>
                  {region.zip_code ? region.zip_code : (
                    <span className="text-muted-foreground italic">None</span>
                  )}
                </TableCell>
                {showProviderName && (
                  <TableCell>{region.provider_name || `Provider ${region.provider_id}`}</TableCell>
                )}
                <TableCell className="text-right">
                  {showVersions && (
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => handleViewVersions(region)}
                    >
                      <Eye className="h-4 w-4 mr-2" />
                      View Versions
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
} 